import type { GameDef } from '../registry';
import { tacoSlapDef } from './def';
import { mountTacoSlap } from './view';

export const tacoSlap: GameDef = { ...tacoSlapDef, mount: mountTacoSlap };
